const STATIC_CHANNELS_DATA_RAW = [
  {
    "channel_name": "TOP BARÇA",
    "channel_page_url": "https://www.freelivesports.tv/channel/top-barca/",
    "thumbnail_image_url": "https://gizmeon.mdc.akamaized.net/files/web/images/fls/uploads/2026/01/topbarca-channel-v1.jpg",
    "channel_id": 2018,
    "description": "A round-the-clock FC Barcelona channel featuring delayed men's and women's match broadcasts, Barça Atlètic and youth team games, sport-wide highlights, original series and documentaries from Barça Studios, plus an archive of historic matches and legendary players.",
    "bg_image_url": "https://gizmeon.mdc.akamaized.net/files/web/images/fls/uploads/2026/01/topbarcaspain-bg.jpg"
  },
  {
    "channel_name": "Pac 12 Insider",
    "channel_page_url": "https://www.freelivesports.tv/channel/pac-12-insider/",
    "thumbnail_image_url": "https://gizmeon.mdc.akamaized.net/files/web/images/fls/uploads/2025/04/pac12v4-channel.jpg",
    "channel_id": 2067,
    "description": "A free streaming channel dedicated to West Coast and Pac-12 sports, offering NCAA Division I events, football and basketball analysis, and an archive celebrating Olympians and conference legends.",
    "bg_image_url": "https://gizmeon.mdc.akamaized.net/files/web/images/fls/uploads/2025/04/pac12-bg.jpg"
  },
  {
    "channel_name": "Golf News Network TV",
    "channel_page_url": "https://www.freelivesports.tv/?page_id=14326",
    "thumbnail_image_url": "https://gizmeon.mdc.akamaized.net/files/web/images/fls/uploads/2024/11/golf-news-channel-683x1024-reduced.jpg",
    "channel_id": null,
    "description": "A news channel for golf fans covering leaderboards, purses and payouts, and betting/fantasy golf insights, with coverage spanning the PGA Tour, LPGA and LIV Golf."
  },
  {
    "channel_name": "Fite 24/7",
    "channel_page_url": "https://www.freelivesports.tv/channel/fite-24-7/",
    "thumbnail_image_url": "https://gizmeon.mdc.akamaized.net/files/web/images/fls/uploads/2024/11/channels-Fite24-7-683x1024-reduced.jpg",
    "channel_id": null,
    "description": "A combat-sports channel featuring boxing, Ring of Honor pro wrestling, M-1 Challenge MMA, and marquee crossover events such as Tyson vs. Jones and KSI vs. Logan Paul.",
    "bg_image_url": "https://gizmeon.mdc.akamaized.net/files/web/images/fls/uploads/2025/03/modal-bg.jpg"
  },
  {
    "channel_name": "WPT LIVE!",
    "channel_page_url": "https://www.freelivesports.tv/channel/wpt-live/",
    "thumbnail_image_url": "https://gizmeon.mdc.akamaized.net/files/web/images/fls/uploads/2024/11/wptliveavatar-683x1024-reduced.jpg",
    "channel_id": 1985,
    "description": "A 24/7 companion channel to the World Poker Tour, streaming WPT programming and live poker action around the clock.",
    "bg_image_url": "https://gizmeon.mdc.akamaized.net/files/web/images/fls/uploads/2025/03/modal-bg.jpg"
  },
  {
    "channel_name": "Foosball TV",
    "channel_page_url": "https://www.freelivesports.tv/channel/foosball-tv/",
    "thumbnail_image_url": "https://gizmeon.mdc.akamaized.net/files/web/images/fls/uploads/2024/11/channels-FoosballTV-683x1024-reduced.jpg",
    "channel_id": 2010,
    "description": "A channel dedicated to table soccer/foosball, offering competitive matches and content for both newcomers and seasoned players of the sport.",
    "bg_image_url": "https://gizmeon.mdc.akamaized.net/files/web/images/fls/uploads/2025/03/modal-bg.jpg"
  },
  {
    "channel_name": "Lacrosse TV",
    "channel_page_url": "https://www.freelivesports.tv/channel/lacrosse-tv/",
    "thumbnail_image_url": "https://gizmeon.mdc.akamaized.net/files/web/images/fls/uploads/2024/11/channels-LacrosseTV-683x1024-reduced.jpg",
    "channel_id": 2012,
    "description": "A channel dedicated to lacrosse, featuring high school, collegiate and professional games alongside documentaries and highlights of the sport.",
    "bg_image_url": "https://gizmeon.mdc.akamaized.net/files/web/images/fls/uploads/2025/03/modal-bg.jpg"
  },
  {
    "channel_name": "Perfect Game TV",
    "channel_page_url": "https://www.freelivesports.tv/channel/perfect-game-tv/",
    "thumbnail_image_url": "https://gizmeon.mdc.akamaized.net/files/web/images/fls/uploads/2024/11/channels-PerfectGameTV-683x1024-reduced.jpg",
    "channel_id": 2014,
    "description": "A channel spotlighting up-and-coming amateur baseball and softball talent, with live games, player interviews, analysis and documentaries following athletes on their way to stardom.",
    "bg_image_url": "https://gizmeon.mdc.akamaized.net/files/web/images/fls/uploads/2023/03/PerfectGame_7-1.jpg"
  },
  {
    "channel_name": "SportsGrid",
    "channel_page_url": "https://www.freelivesports.tv/channel/sportsgrid/",
    "thumbnail_image_url": "https://gizmeon.mdc.akamaized.net/files/web/images/fls/uploads/2024/12/sportsgrid2-channel.jpg",
    "channel_id": 2062,
    "description": "A 24-hour streaming sports news channel producing original programming from state-of-the-art studios, with daily coverage of the NFL, MLB, NBA, NHL, NCAA college sports, golf, tennis, soccer and major sporting events.",
    "bg_image_url": "https://gizmeon.mdc.akamaized.net/files/web/images/fls/uploads/2022/04/sportsgrid.jpg"
  },
  {
    "channel_name": "World Poker Tour",
    "channel_page_url": "https://www.freelivesports.tv/channel/world-poker-tour/",
    "thumbnail_image_url": "https://gizmeon.mdc.akamaized.net/files/web/images/fls/uploads/2024/11/channels-WPT-683x1024-reduced.jpg",
    "channel_id": 1988,
    "description": "The channel behind the TV show credited with sparking the modern poker boom, following a series of high-stakes tournaments that turned players like Gus Hansen and Daniel Negreanu into household names in the poker world.",
    "bg_image_url": "https://gizmeon.mdc.akamaized.net/files/web/images/fls/uploads/2025/03/modal-bg.jpg"
  },
  {
    "channel_name": "Poker Night",
    "channel_page_url": "https://www.freelivesports.tv/channel/poker-night/",
    "thumbnail_image_url": "https://gizmeon.mdc.akamaized.net/files/web/images/fls/uploads/2024/11/channels-PokerNight-683x1024-reduced.jpg",
    "channel_id": 1986,
    "description": "A poker channel airing Poker Night in America, featuring cash games and sit-and-go tournaments filmed live at casinos across the United States.",
    "bg_image_url": "https://gizmeon.mdc.akamaized.net/files/web/images/fls/uploads/2025/03/modal-bg.jpg"
  },
  {
    "channel_name": "Extreme",
    "channel_page_url": "https://www.freelivesports.tv/channel/extreme-sports/",
    "thumbnail_image_url": "https://gizmeon.mdc.akamaized.net/files/web/images/fls/uploads/2025/04/extreme-channel.jpg",
    "channel_id": null,
    "description": "An action-sports channel covering surfing, skateboarding, snowboarding, wakeboarding, motocross, BMX, mountain biking and freestyle motocross, alongside music, gaming and urban fashion content.",
    "bg_image_url": "https://gizmeon.mdc.akamaized.net/files/web/images/fls/uploads/2025/03/modal-bg.jpg"
  },
  {
    "channel_name": "Horse & Country",
    "channel_page_url": "https://www.freelivesports.tv/channel/horse-and-country/",
    "thumbnail_image_url": "https://gizmeon.mdc.akamaized.net/files/web/images/fls/uploads/2024/11/channels-H_C-683x1024-reduced.jpg",
    "channel_id": 1971,
    "description": "An international equestrian sports network covering showjumping, dressage and eventing competitions, plus training masterclasses, documentaries and original equestrian entertainment.",
    "bg_image_url": "https://gizmeon.mdc.akamaized.net/files/web/images/fls/uploads/2025/03/modal-bg.jpg"
  },
  {
    "channel_name": "Choppertown",
    "channel_page_url": "https://www.freelivesports.tv/channel/choppertown/",
    "thumbnail_image_url": "https://gizmeon.mdc.akamaized.net/files/web/images/fls/uploads/2024/11/channels-Choppertown-683x1024-reduced.jpg",
    "channel_id": 1962,
    "description": "A channel featuring biker culture films and documentaries centered on custom motorcycle and hot rod clubs, chopper builders and the wider biker lifestyle.",
    "bg_image_url": "https://gizmeon.mdc.akamaized.net/files/web/images/fls/uploads/2025/03/modal-bg.jpg"
  },
  {
    "channel_name": "Hard Knocks",
    "channel_page_url": "https://www.freelivesports.tv/channel/hard-knocks/",
    "thumbnail_image_url": "https://gizmeon.mdc.akamaized.net/files/web/images/fls/uploads/2024/11/channels-HardKnocks-683x1024-reduced.jpg",
    "channel_id": 2029,
    "description": "An MMA-focused channel offering behind-the-scenes access to mixed martial arts, showcasing elite fighters and serving as a launching pad for several current MMA stars.",
    "bg_image_url": "https://gizmeon.mdc.akamaized.net/files/web/images/fls/uploads/2025/03/modal-bg.jpg"
  },
  {
    "channel_name": "Wired2Fish",
    "channel_page_url": "https://www.freelivesports.tv/channel/wired2fish/",
    "thumbnail_image_url": "https://gizmeon.mdc.akamaized.net/files/web/images/fls/uploads/2024/11/channels-Wired2Fish-683x1024-reduced.jpg",
    "channel_id": 1978,
    "description": "A fishing channel covering tackle reviews, techniques, tournaments and news, with a strong focus on bass fishing alongside coverage of other freshwater species.",
    "bg_image_url": "https://gizmeon.mdc.akamaized.net/files/web/images/fls/uploads/2025/03/modal-bg.jpg"
  },
  {
    "channel_name": "RACER Select",
    "channel_page_url": "https://www.freelivesports.tv/channel/racer-select/",
    "thumbnail_image_url": "https://gizmeon.mdc.akamaized.net/files/web/images/fls/uploads/2025/04/racer-select-channel.jpg",
    "channel_id": null,
    "description": "A motorsports entertainment channel offering original series, acquired documentaries, and current-season motorsport programming in one place.",
    "bg_image_url": "https://gizmeon.mdc.akamaized.net/files/web/images/fls/uploads/2025/03/modal-bg.jpg"
  },
  {
    "channel_name": "RACER International",
    "channel_page_url": "https://www.freelivesports.tv/channel/racer-international/",
    "thumbnail_image_url": "https://gizmeon.mdc.akamaized.net/files/web/images/fls/uploads/2025/04/racer-int-channel.jpg",
    "channel_id": 2049,
    "description": "An automotive-rooted motorsports network covering events like the Chili Bowl, AMA Pro Motocross and NHRA Drag Racing, alongside global disciplines such as drag boats, rally racing, drifting, dirt racing and ice racing.",
    "bg_image_url": "https://gizmeon.mdc.akamaized.net/files/web/images/fls/uploads/2025/03/modal-bg.jpg"
  },
  {
    "channel_name": "NHRA",
    "channel_page_url": "https://www.freelivesports.tv/channel/nhra/",
    "thumbnail_image_url": "https://gizmeon.mdc.akamaized.net/files/web/images/fls/uploads/2024/11/channels-NHRA-683x1024-reduced.jpg",
    "channel_id": 2043,
    "description": "The National Hot Rod Association's channel for drag racing, streaming Top Fuel, Funny Car, Pro Stock and Pro Stock Motorcycle events live alongside an archive of past races.",
    "bg_image_url": "https://gizmeon.mdc.akamaized.net/files/web/images/fls/uploads/2025/03/modal-bg.jpg"
  },
  {
    "channel_name": "eClutch Access",
    "channel_page_url": "https://www.freelivesports.tv/channel/eclutch-access/",
    "thumbnail_image_url": "https://gizmeon.mdc.akamaized.net/files/web/images/fls/uploads/2025/08/eclutch-channel.jpg",
    "channel_id": 1960,
    "description": "An esports channel covering competitive gaming worldwide, with live tournaments, pro-player highlights and gaming content built for TV audiences.",
    "bg_image_url": "https://gizmeon.mdc.akamaized.net/files/web/images/fls/uploads/2025/08/eclutch-bg.jpg"
  },
  {
    "channel_name": "RPM Motorsport",
    "channel_page_url": "https://www.freelivesports.tv/channel/rpm-motorsport/",
    "thumbnail_image_url": "https://gizmeon.mdc.akamaized.net/files/web/images/fls/uploads/2024/11/channels-RPMmotorsport-683x1024-reduced.jpg",
    "channel_id": 2042,
    "description": "A rally-racing channel covering circuit and stage rally events from around the world for motorsport fans who love speed.",
    "bg_image_url": "https://gizmeon.mdc.akamaized.net/files/web/images/fls/uploads/2021/11/Fun-Cup-Review-.jpg"
  },
  {
    "channel_name": "MTRSPT1",
    "channel_page_url": "https://www.freelivesports.tv/channel/mtrspt1/",
    "thumbnail_image_url": "https://gizmeon.mdc.akamaized.net/files/web/images/fls/uploads/2024/11/mtrspt1-channel-683x1024-reduced.jpg",
    "channel_id": 2047,
    "description": "A round-the-clock motorsports network airing top-tier racing coverage alongside motorsport shows, documentaries and lifestyle programming.",
    "bg_image_url": "https://gizmeon.mdc.akamaized.net/files/web/images/fls/uploads/2025/03/modal-bg.jpg"
  },
  {
    "channel_name": "My Padel TV",
    "channel_page_url": "https://www.freelivesports.tv/channel/my-padel-tv/",
    "thumbnail_image_url": "https://gizmeon.mdc.akamaized.net/files/web/images/fls/uploads/2025/05/my-padel-channel.jpg",
    "channel_id": 2005,
    "description": "A channel dedicated to padel, streaming live competitions, behind-the-scenes lifestyle features and original content for fans of the fast-growing racquet sport.",
    "bg_image_url": "https://gizmeon.mdc.akamaized.net/files/web/images/fls/uploads/2025/05/my-padel-bg.jpg"
  },
  {
    "channel_name": "More U",
    "channel_page_url": "https://www.freelivesports.tv/channel/more-u/",
    "thumbnail_image_url": "https://gizmeon.mdc.akamaized.net/files/web/images/fls/uploads/2024/12/moreu-channel.jpg",
    "channel_id": 1945,
    "description": "A health and personal-development channel featuring motivational programming and wellness guidance from well-known self-help and mindfulness speakers.",
    "bg_image_url": "https://gizmeon.mdc.akamaized.net/files/web/images/fls/uploads/2024/12/moreu-bg.jpg"
  },
  {
    "channel_name": "Sports Illustrated TV",
    "channel_page_url": "https://www.freelivesports.tv/channel/sports-illustrated-tv/",
    "thumbnail_image_url": "https://gizmeon.mdc.akamaized.net/files/web/images/fls/uploads/2025/09/sports-ill-channel.jpg",
    "channel_id": 2066,
    "description": "A channel built on Sports Illustrated's storytelling, offering original sports films, documentaries and shows that go behind the scenes with athletes and coaches.",
    "bg_image_url": "https://gizmeon.mdc.akamaized.net/files/web/images/fls/uploads/2025/09/sports-ill-bg.jpg"
  },
  {
    "channel_name": "Motorvision",
    "channel_page_url": "https://www.freelivesports.tv/channel/motorvision-tv/",
    "thumbnail_image_url": "https://gizmeon.mdc.akamaized.net/files/web/images/fls/uploads/2024/11/channels-MotorvisionTV-683x1024-reduced.jpg",
    "channel_id": 2040,
    "description": "An automotive channel spanning the car world from luxury limousines and supercars to 4x4s, trucks and classic cars, alongside racing coverage.",
    "bg_image_url": "https://gizmeon.mdc.akamaized.net/files/web/images/fls/uploads/2025/03/modal-bg.jpg"
  },
  {
    "channel_name": "Tennis TV",
    "channel_page_url": "https://www.freelivesports.tv/channel/tennis-tv/",
    "thumbnail_image_url": "https://gizmeon.mdc.akamaized.net/files/web/images/fls/uploads/2025/09/tennis-tv-channel.jpg",
    "channel_id": 2007,
    "description": "A channel billed as the best seat in tennis, delivering coverage of the professional tour for fans of the sport.",
    "bg_image_url": "https://gizmeon.mdc.akamaized.net/files/web/images/fls/uploads/2025/03/modal-bg.jpg"
  },
  {
    "channel_name": "Tennis Channel",
    "channel_page_url": "https://www.freelivesports.tv/channel/tennis-channel/",
    "thumbnail_image_url": "https://gizmeon.mdc.akamaized.net/files/web/images/fls/uploads/2024/11/channels-TennisChannel-683x1024-reduced.jpg",
    "channel_id": null,
    "description": "A 24-hour multimedia destination dedicated to professional tennis and the broader tennis lifestyle.",
    "bg_image_url": "https://gizmeon.mdc.akamaized.net/files/web/images/fls/uploads/2025/03/modal-bg.jpg"
  },
  {
    "channel_name": "GINX TV",
    "channel_page_url": "https://www.freelivesports.tv/channel/ginx-tv/",
    "thumbnail_image_url": "https://gizmeon.mdc.akamaized.net/files/web/images/fls/uploads/2025/04/ginx-channel.jpg",
    "channel_id": null,
    "description": "A gaming and esports channel running around the clock since 2007, mixing gaming news, live esports coverage and original shows for casual and hardcore players alike.",
    "bg_image_url": "https://gizmeon.mdc.akamaized.net/files/web/images/fls/uploads/2025/04/ginx-bg-v2.jpg"
  },
  {
    "channel_name": "Strongman Champions League",
    "channel_page_url": "https://www.freelivesports.tv/channel/strongman-champions-league/",
    "thumbnail_image_url": "https://gizmeon.mdc.akamaized.net/files/web/images/fls/uploads/2024/11/channels-Strongman-683x1024-reduced.jpg",
    "channel_id": 1964,
    "description": "A round-the-clock strength-sports channel featuring the Strongman Champions League circuit, with athletes competing in events like truck pulls and log lifts across multiple international stages each year.",
    "bg_image_url": "https://gizmeon.mdc.akamaized.net/files/web/images/fls/uploads/2025/03/modal-bg.jpg"
  },
  {
    "channel_name": "MMA-TV",
    "channel_page_url": "https://www.freelivesports.tv/channel/mma-tv/",
    "thumbnail_image_url": "https://gizmeon.mdc.akamaized.net/files/web/images/fls/uploads/2025/02/mma-channel.jpg",
    "channel_id": 2024,
    "description": "A round-the-clock mixed martial arts channel featuring fights, fighter interviews, expert analysis and behind-the-scenes combat sports coverage.",
    "bg_image_url": "https://gizmeon.mdc.akamaized.net/files/web/images/fls/uploads/2025/02/mma-bg.png"
  },
  {
    "channel_name": "MVMT Culture",
    "channel_page_url": "https://www.freelivesports.tv/channel/mvmt-culture/",
    "thumbnail_image_url": "https://gizmeon.mdc.akamaized.net/files/web/images/fls/uploads/2024/11/mvmt-channel-683x1024-reduced.jpg",
    "channel_id": 2028,
    "description": "A grappling and martial-arts education channel breaking down Brazilian Jiu-Jitsu, Judo and wrestling techniques, paired with stories about discipline and perseverance in the sport.",
    "bg_image_url": "https://gizmeon.mdc.akamaized.net/files/web/images/fls/uploads/2025/03/modal-bg.jpg"
  },
  {
    "channel_name": "Fight Network",
    "channel_page_url": "https://www.freelivesports.tv/channel/fight-network/",
    "thumbnail_image_url": "https://gizmeon.mdc.akamaized.net/files/web/images/fls/uploads/2024/11/channels-FightNetwork-683x1024-reduced.jpg",
    "channel_id": 2030,
    "description": "A combat-sports channel spanning MMA, boxing, kickboxing, professional wrestling and traditional martial arts, mixing live fight coverage with news, documentaries and fight-themed programming.",
    "bg_image_url": "https://gizmeon.mdc.akamaized.net/files/web/images/fls/uploads/2025/03/modal-bg.jpg"
  },
  {
    "channel_name": "GoPro TV",
    "channel_page_url": "https://www.freelivesports.tv/channel/go-pro-tv/",
    "thumbnail_image_url": "https://gizmeon.mdc.akamaized.net/files/web/images/fls/uploads/2025/02/gopro-channel.jpg",
    "channel_id": 1996,
    "description": "An action-sports channel built around first-person, POV-style footage from the GoPro community, spanning extreme sports, adventure, travel and outdoor culture.",
    "bg_image_url": "https://gizmeon.mdc.akamaized.net/files/web/images/fls/uploads/2025/02/gopro-bg.jpg"
  },
  {
    "channel_name": "TNA Wrestling Channel",
    "channel_page_url": "https://www.freelivesports.tv/channel/tna-wrestling-channel/",
    "thumbnail_image_url": "https://gizmeon.mdc.akamaized.net/files/web/images/fls/uploads/2024/11/channels-Impact-683x1024-reduced.jpg",
    "channel_id": 2035,
    "description": "A professional wrestling channel from TNA featuring its roster of athletes in ongoing storylines and matches.",
    "bg_image_url": "https://gizmeon.mdc.akamaized.net/files/web/images/fls/uploads/2025/03/modal-bg.jpg"
  },
  {
    "channel_name": "PokerGO",
    "channel_page_url": "https://www.freelivesports.tv/channel/pokergo/",
    "thumbnail_image_url": "https://gizmeon.mdc.akamaized.net/files/web/images/fls/uploads/2024/11/channels-PokerGO-683x1024-reduced.jpg",
    "channel_id": 1987,
    "description": "A leading poker entertainment channel featuring the World Series of Poker (WSOP), High Stakes Poker and Poker After Dark, alongside other exclusive tournament coverage.",
    "bg_image_url": "https://gizmeon.mdc.akamaized.net/files/web/images/fls/uploads/2022/05/pokergo-thumb.png"
  },
  {
    "channel_name": "Powersports World",
    "channel_page_url": "https://www.freelivesports.tv/channel/powersports-world/",
    "thumbnail_image_url": "https://gizmeon.mdc.akamaized.net/files/web/images/fls/uploads/2025/01/powersports-channel.jpg",
    "channel_id": 2044,
    "description": "A channel for riders, racers and explorers covering powersports content across motorcycles, off-road and adventure riding.",
    "bg_image_url": "https://gizmeon.mdc.akamaized.net/files/web/images/fls/uploads/2025/03/modal-bg.jpg"
  },
  {
    "channel_name": "Fuel TV",
    "channel_page_url": "https://www.freelivesports.tv/channel/fuel-tv/",
    "thumbnail_image_url": "https://gizmeon.mdc.akamaized.net/files/web/images/fls/uploads/2024/11/channels-FuelTV-683x1024-reduced.jpg",
    "channel_id": 1989,
    "description": "An action-sports channel dedicated to skateboarding, surfing, wakeboarding, snowboarding, mountain biking and BMX, alongside the youth culture surrounding these sports.",
    "bg_image_url": "https://gizmeon.mdc.akamaized.net/files/web/images/fls/uploads/2025/03/modal-bg.jpg"
  },
  {
    "channel_name": "WPT Spain",
    "channel_page_url": "https://www.freelivesports.tv/channel/wpt-spain/",
    "thumbnail_image_url": "https://gizmeon.mdc.akamaized.net/files/web/images/fls/uploads/2024/11/channels-WPTSpain-1-683x1024-reduced.jpg",
    "channel_id": 1984,
    "description": "The Spanish-language home of the World Poker Tour, following high-stakes tournaments and star players such as Phil Ivey, Doyle Brunson and Daniel Negreanu.",
    "bg_image_url": "https://gizmeon.mdc.akamaized.net/files/web/images/fls/uploads/2025/03/modal-bg.jpg"
  },
  {
    "channel_name": "Cornhole TV",
    "channel_page_url": "https://www.freelivesports.tv/channel/cornhole-tv/",
    "thumbnail_image_url": "https://gizmeon.mdc.akamaized.net/files/web/images/fls/uploads/2024/11/channels-CornholeTV-683x1024-reduced.jpg",
    "channel_id": 2011,
    "description": "A channel dedicated to competitive cornhole, following the American Cornhole League's matches and tournaments, where players of all backgrounds compete.",
    "bg_image_url": "https://gizmeon.mdc.akamaized.net/files/web/images/fls/uploads/2025/03/modal-bg.jpg"
  },
  {
    "channel_name": "InTrouble",
    "channel_page_url": "https://www.freelivesports.tv/channel/introuble/",
    "thumbnail_image_url": "https://gizmeon.mdc.akamaized.net/files/web/images/fls/uploads/2024/11/channels-Introuble-683x1024-reduced.jpg",
    "channel_id": null,
    "description": "A channel for gearheads and adrenaline seekers, mixing cars, survival stories and action sports content.",
    "bg_image_url": "https://gizmeon.mdc.akamaized.net/files/web/images/fls/uploads/2025/03/modal-bg.jpg"
  },
  {
    "channel_name": "DFB Play TV",
    "channel_page_url": "https://www.freelivesports.tv/channel/dfb-play-tv/",
    "thumbnail_image_url": "https://gizmeon.mdc.akamaized.net/files/web/images/fls/uploads/2025/06/dfb-channel.jpg",
    "channel_id": 2021,
    "description": "The German football channel featuring live DFB-Pokal matches and other national-team and cup content, plus on-demand highlights.",
    "bg_image_url": "https://gizmeon.mdc.akamaized.net/files/web/images/fls/uploads/2025/06/dfb-bg.jpg"
  },
  {
    "channel_name": "World Surf League",
    "channel_page_url": "https://www.freelivesports.tv/channel/world-surf-league/",
    "thumbnail_image_url": "https://gizmeon.mdc.akamaized.net/files/web/images/fls/uploads/2025/11/wsl-channel-v2.jpg",
    "channel_id": 1998,
    "description": "A surfing channel covering the professional tour, with surfer rankings, competition highlights, interviews and behind-the-scenes content from events around the world.",
    "bg_image_url": "https://gizmeon.mdc.akamaized.net/files/web/images/fls/uploads/2025/11/wsl-bg-v2.jpg"
  },
  {
    "channel_name": "Surf Cinema",
    "channel_page_url": "https://www.freelivesports.tv/channel/surf-cinema/",
    "thumbnail_image_url": "https://gizmeon.mdc.akamaized.net/files/web/images/fls/uploads/2025/06/surfcin-channel.jpg",
    "channel_id": 1997,
    "description": "A surfing lifestyle channel featuring wave-riding footage, interviews with surf legends, and coverage of surf destinations and culture.",
    "bg_image_url": "https://gizmeon.mdc.akamaized.net/files/web/images/fls/uploads/2023/12/SurferPromo2.jpg"
  },
  {
    "channel_name": "Trace Sport Stars",
    "channel_page_url": "https://www.freelivesports.tv/channel/trace-sport-stars/",
    "thumbnail_image_url": "https://gizmeon.mdc.akamaized.net/files/web/images/fls/uploads/2024/11/channels-TraceSportStars-683x1024-reduced.jpg",
    "channel_id": 1956,
    "description": "An entertainment channel focused on the personal lives of sports celebrities, mixing lifestyle, magazine-style, and reality programming built around athletes.",
    "bg_image_url": "https://gizmeon.mdc.akamaized.net/files/web/images/fls/uploads/2023/10/trace.png"
  },
  {
    "channel_name": "Kozoom",
    "channel_page_url": "https://www.freelivesports.tv/channel/kozoom/",
    "thumbnail_image_url": "https://gizmeon.mdc.akamaized.net/files/web/images/fls/uploads/2024/11/channels-Kozoom-683x1024-reduced.jpg",
    "channel_id": 1982,
    "description": "A billiards channel covering top competitions in carom and pool, plus instructional masterclasses from elite cue-sport players.",
    "bg_image_url": "https://gizmeon.mdc.akamaized.net/files/web/images/fls/uploads/2025/03/modal-bg.jpg"
  },
  {
    "channel_name": "PFL",
    "channel_page_url": "https://www.freelivesports.tv/channel/pfl/",
    "thumbnail_image_url": "https://gizmeon.mdc.akamaized.net/files/web/images/fls/uploads/2024/11/channels-PFL-683x1024-reduced.jpg",
    "channel_id": 2036,
    "description": "The channel for the Professional Fighters League, MMA's season-and-playoff format where fighters compete toward the PFL World Championship and a $1 million title prize.",
    "bg_image_url": "https://gizmeon.mdc.akamaized.net/files/web/images/fls/uploads/2025/03/modal-bg.jpg"
  },
  {
    "channel_name": "Eurovision Sport",
    "channel_page_url": "https://www.freelivesports.tv/channel/eurovision-sport/",
    "thumbnail_image_url": "https://gizmeon.mdc.akamaized.net/files/web/images/fls/uploads/2026/03/eurovision-channel.jpg",
    "channel_id": null,
    "description": "A channel produced with EBU member broadcasters covering track and field, athletics and other Olympic-style sports with live events, highlights and on-demand replays.",
    "bg_image_url": "https://gizmeon.mdc.akamaized.net/files/web/images/fls/uploads/2026/03/eurovision-bg.jpg"
  },
  {
    "channel_name": "Omstars TV",
    "channel_page_url": "https://www.freelivesports.tv/channel/omstars-tv/",
    "thumbnail_image_url": "https://gizmeon.mdc.akamaized.net/files/web/images/fls/uploads/2024/11/channels-OmstarsTV-683x1024-reduced.jpg",
    "channel_id": null,
    "description": "A health and wellness channel centered on yoga, meditation and mindful living, with plant-based cooking and philosophy content for practitioners at any level.",
    "bg_image_url": "https://gizmeon.mdc.akamaized.net/files/web/images/fls/uploads/2025/03/modal-bg.jpg"
  },
  {
    "channel_name": "Hunt Fish TV",
    "channel_page_url": "https://www.freelivesports.tv/channel/hunt-fish-tv/",
    "thumbnail_image_url": "https://gizmeon.mdc.akamaized.net/files/web/images/fls/uploads/2024/11/channels-HuntFishTV-683x1024-reduced.jpg",
    "channel_id": 1977,
    "description": "A hunting and fishing channel offering outdoor programming for anglers and hunters.",
    "bg_image_url": "https://gizmeon.mdc.akamaized.net/files/web/images/fls/uploads/2025/03/modal-bg.jpg"
  },
  {
    "channel_name": "World Of Freesports",
    "channel_page_url": "https://www.freelivesports.tv/channel/world-of-freesports/",
    "thumbnail_image_url": "https://gizmeon.mdc.akamaized.net/files/web/images/fls/uploads/2024/11/channels-World-of-Freesports-683x1024-reduced.jpg",
    "channel_id": 1994,
    "description": "A channel focused on extreme performance in action and outdoor sports, showcasing the world of freesports from an insider's perspective.",
    "bg_image_url": "https://gizmeon.mdc.akamaized.net/files/web/images/fls/uploads/2025/03/modal-bg.jpg"
  },
  {
    "channel_name": "GCTV",
    "channel_page_url": "https://www.freelivesports.tv/channel/gctv/",
    "thumbnail_image_url": "https://gizmeon.mdc.akamaized.net/files/web/images/fls/uploads/2024/11/channels-GCTV-683x1024-reduced.jpg",
    "channel_id": 1970,
    "description": "An equestrian channel dedicated to elite show jumping, airing coverage of top competitions from prestigious venues around the world.",
    "bg_image_url": "https://gizmeon.mdc.akamaized.net/files/web/images/fls/uploads/2025/03/modal-bg.jpg"
  },
  {
    "channel_name": "Stadium",
    "channel_page_url": "https://www.freelivesports.tv/channel/stadium/",
    "thumbnail_image_url": "https://gizmeon.mdc.akamaized.net/files/web/images/fls/uploads/2024/11/channels-Stadium-683x1024-reduced.jpg",
    "channel_id": null,
    "description": "A multi-platform sports channel with round-the-clock college and pro sports news, analysis and conversation, covering football, basketball and other major leagues.",
    "bg_image_url": "https://gizmeon.mdc.akamaized.net/files/web/images/fls/uploads/2023/11/stadium.jpg"
  },
  {
    "channel_name": "RVTV",
    "channel_page_url": "https://www.freelivesports.tv/channel/rvtv/",
    "thumbnail_image_url": "https://gizmeon.mdc.akamaized.net/files/web/images/fls/uploads/2025/12/rvtv-channel.jpg",
    "channel_id": 1957,
    "description": "A channel for the recreational-vehicle lifestyle, covering RV reviews, maintenance tips, buying guides and road-trip travel destinations for RVers of all experience levels."
  },
  {
    "channel_name": "Pursuit Up",
    "channel_page_url": "https://www.freelivesports.tv/channel/pursuit-up/",
    "thumbnail_image_url": "https://gizmeon.mdc.akamaized.net/files/web/images/fls/uploads/2024/11/channels-PursuitUp-683x1024-reduced.jpg",
    "channel_id": 1975,
    "description": "An outdoor lifestyle channel for hunters and anglers, offering fishing, hunting and outdoors programming aimed at helping viewers succeed in the field.",
    "bg_image_url": "https://gizmeon.mdc.akamaized.net/files/web/images/fls/uploads/2024/01/MossyOak-2-1.jpg"
  },
  {
    "channel_name": "Lucha Plus",
    "channel_page_url": "https://www.freelivesports.tv/channel/lucha-plus/",
    "thumbnail_image_url": "https://gizmeon.mdc.akamaized.net/files/web/images/fls/uploads/2025/03/lucha-channel.jpg",
    "channel_id": 2034,
    "description": "A channel for Lucha Libre fans, offering live and recorded matches plus original variety and news programming built around Mexican professional wrestling.",
    "bg_image_url": "https://gizmeon.mdc.akamaized.net/files/web/images/fls/uploads/2025/03/lucha-bg.jpg"
  },
  {
    "channel_name": "Absinthe TV",
    "channel_page_url": "https://www.freelivesports.tv/channel/absinthe-tv/",
    "thumbnail_image_url": "https://gizmeon.mdc.akamaized.net/files/web/images/fls/uploads/2025/06/absynthe-channel-v2.jpg",
    "channel_id": 1990,
    "description": "An adventure-sports and culture channel covering surf, skate and snow films alongside underground music and art from creators shaping those scenes.",
    "bg_image_url": "https://gizmeon.mdc.akamaized.net/files/web/images/fls/uploads/2025/05/absintghe-bgv2.jpg"
  },
  {
    "channel_name": "Swerve Sports",
    "channel_page_url": "https://www.freelivesports.tv/channel/swerve-sports/",
    "thumbnail_image_url": "https://gizmeon.mdc.akamaized.net/files/web/images/fls/uploads/2025/06/swerve-channel-v2.jpg",
    "channel_id": null,
    "description": "A channel dedicated to women's sports, streaming live games, top matches and athlete stories across a range of women's leagues and competitions.",
    "bg_image_url": "https://gizmeon.mdc.akamaized.net/files/web/images/fls/uploads/2025/06/swerve-bg.jpg"
  },
  {
    "channel_name": "Horse TV",
    "channel_page_url": "https://www.freelivesports.tv/channel/horse-tv/",
    "thumbnail_image_url": "https://gizmeon.mdc.akamaized.net/files/web/images/fls/uploads/2024/11/channels-HorseTV-683x1024-reduced.jpg",
    "channel_id": 1969,
    "description": "An international equestrian channel bringing round-the-clock coverage of horse sports to fans worldwide, capturing the power and elegance of the discipline.",
    "bg_image_url": "https://gizmeon.mdc.akamaized.net/files/web/images/fls/uploads/2024/03/horsetvthumb.jpg"
  },
  {
    "channel_name": "FloRacing",
    "channel_page_url": "https://www.freelivesports.tv/channel/floracing/",
    "thumbnail_image_url": "https://gizmeon.mdc.akamaized.net/files/web/images/fls/uploads/2024/11/floracing-channel-683x1024-reduced.jpg",
    "channel_id": 2041,
    "description": "A dirt-track and oval-racing channel offering live motorsports coverage, highlights and analysis for fans of professional dirt track racing.",
    "bg_image_url": "https://gizmeon.mdc.akamaized.net/files/web/images/fls/uploads/2024/09/larson-3.jpg"
  },
  {
    "channel_name": "Swerve Combat",
    "channel_page_url": "https://www.freelivesports.tv/channel/swerve-combat/",
    "thumbnail_image_url": "https://gizmeon.mdc.akamaized.net/files/web/images/fls/uploads/2024/11/swerve-channel-683x1024-reduced.jpg",
    "channel_id": null,
    "description": "A combat-sports storytelling channel featuring documentaries and biopics on fighters, along with MMA, boxing and Muay Thai competitions and reality-style programming.",
    "bg_image_url": "https://gizmeon.mdc.akamaized.net/files/web/images/fls/uploads/2024/10/swerve-bg-v4.png"
  },
  {
    "channel_name": "Willow Sports",
    "channel_page_url": "https://www.freelivesports.tv/channel/willow-sports/",
    "thumbnail_image_url": "https://gizmeon.mdc.akamaized.net/files/web/images/fls/uploads/2024/11/willow-sports-channel-683x1024-reduced.jpg",
    "channel_id": null,
    "description": "A 24/7 cricket channel offering coverage of international matches, tournaments and domestic leagues in HD, including ICC events.",
    "bg_image_url": "https://gizmeon.mdc.akamaized.net/files/web/images/fls/uploads/2024/10/willow-bg.jpg"
  },
  {
    "channel_name": "Goal TV",
    "channel_page_url": "https://www.freelivesports.tv/channel/goal-tv/",
    "thumbnail_image_url": "https://gizmeon.mdc.akamaized.net/files/web/images/fls/uploads/2024/11/goal-channel-v2-683x1024-reduced.jpg",
    "channel_id": 2056,
    "description": "A soccer-focused channel covering highlights, player transfers and news from top leagues and teams around the world.",
    "bg_image_url": "https://gizmeon.mdc.akamaized.net/files/web/images/fls/uploads/2024/10/goal-bg.jpg"
  },
  {
    "channel_name": "H2O TV",
    "channel_page_url": "https://www.freelivesports.tv/channel/h20-tv/",
    "thumbnail_image_url": "https://gizmeon.mdc.akamaized.net/files/web/images/fls/uploads/2024/11/h20-channel-683x1024-reduced.jpg",
    "channel_id": null,
    "description": "A water-themed channel featuring original programming across water sports, environmental topics, and travel destinations centered on the water.",
    "bg_image_url": "https://gizmeon.mdc.akamaized.net/files/web/images/fls/uploads/2024/10/h20-bg.jpg"
  },
  {
    "channel_name": "Speed Sport 1",
    "channel_page_url": "https://www.freelivesports.tv/channel/speed-sport-1/",
    "thumbnail_image_url": "https://gizmeon.mdc.akamaized.net/files/web/images/fls/uploads/2025/02/ss1-channel.jpg",
    "channel_id": null,
    "description": "A racing and motorsports channel featuring live events from circuits around the world.",
    "bg_image_url": "https://gizmeon.mdc.akamaized.net/files/web/images/fls/uploads/2024/10/speed-bg.jpg"
  },
  {
    "channel_name": "United Fight Alliance",
    "channel_page_url": "https://www.freelivesports.tv/channel/united-fight-alliance/",
    "thumbnail_image_url": "https://gizmeon.mdc.akamaized.net/files/web/images/fls/uploads/2024/11/ufa-channel-683x1024-reduced.jpg",
    "channel_id": 2031,
    "description": "A combat-sports channel covering MMA, boxing, kickboxing, bare-knuckle boxing and Muay Thai, with fighter interviews and profiles alongside footage from top-ranked and rising fighters.",
    "bg_image_url": "https://gizmeon.mdc.akamaized.net/files/web/images/fls/uploads/2025/03/modal-bg.jpg"
  },
  {
    "channel_name": "PLL – US",
    "channel_page_url": "https://www.freelivesports.tv/channel/premier-league-lacrosse-pll-us/",
    "thumbnail_image_url": "https://gizmeon.mdc.akamaized.net/files/web/images/fls/uploads/2024/11/pll-channel-683x1024-reduced.jpg",
    "channel_id": 2013,
    "description": "The U.S. channel for the Premier Lacrosse League, offering round-the-clock lacrosse content including game highlights, documentaries and archival footage.",
    "bg_image_url": "https://gizmeon.mdc.akamaized.net/files/web/images/fls/uploads/2024/10/pll-bg.png"
  },
  {
    "channel_name": "PLL – International",
    "channel_page_url": "https://www.freelivesports.tv/channel/premier-league-lacrosse-pll-international/",
    "thumbnail_image_url": "https://gizmeon.mdc.akamaized.net/files/web/images/fls/uploads/2024/11/pll-channel-683x1024-reduced.jpg",
    "channel_id": 2013,
    "description": "The international channel for the Premier Lacrosse League, offering round-the-clock lacrosse content including game highlights, documentaries and archival footage.",
    "bg_image_url": "https://gizmeon.mdc.akamaized.net/files/web/images/fls/uploads/2024/10/pll-bg.png"
  },
  {
    "channel_name": "ACE TV",
    "channel_page_url": "https://www.freelivesports.tv/channel/ace-tv/",
    "thumbnail_image_url": "https://gizmeon.mdc.akamaized.net/files/web/images/fls/uploads/2024/11/ace-channel-683x1024-reduced.jpg",
    "channel_id": 2054,
    "description": "A tennis-focused channel covering match coverage, breaking news, live scores and player interviews for fans at every level of the sport.",
    "bg_image_url": "https://gizmeon.mdc.akamaized.net/files/web/images/fls/uploads/2024/10/ace-bg.jpg"
  },
  {
    "channel_name": "HOOP TV",
    "channel_page_url": "https://www.freelivesports.tv/channel/hoop-tv/",
    "thumbnail_image_url": "https://gizmeon.mdc.akamaized.net/files/web/images/fls/uploads/2024/11/hoop-channel-683x1024-reduced.jpg",
    "channel_id": 2057,
    "description": "A basketball-focused channel offering immersive coverage of the sport for casual viewers and dedicated fans alike.",
    "bg_image_url": "https://gizmeon.mdc.akamaized.net/files/web/images/fls/uploads/2024/10/hoop-bg.png"
  },
  {
    "channel_name": "Pickleball TV",
    "channel_page_url": "https://www.freelivesports.tv/channel/pickleball-tv/",
    "thumbnail_image_url": "https://gizmeon.mdc.akamaized.net/files/web/images/fls/uploads/2026/03/pickleball-channel.jpg",
    "channel_id": null,
    "description": "A channel dedicated to pickleball, covering national tournaments, top-ranked player matchups, instructional content and news around the fast-growing sport.",
    "bg_image_url": "https://gizmeon.mdc.akamaized.net/files/web/images/fls/uploads/2026/03/pickleball-bg.jpg"
  },
  {
    "channel_name": "Cricket Gold",
    "channel_page_url": "https://www.freelivesports.tv/channel/cricket-gold/",
    "thumbnail_image_url": "https://gizmeon.mdc.akamaized.net/files/web/images/fls/uploads/2025/03/cricket-gold-channel.jpg",
    "channel_id": 2015,
    "description": "A 24/7 cricket archive channel replaying classic matches from the 1970s through the 2010s, including historic Cricket Australia events and other vintage cricket programming.",
    "bg_image_url": "https://gizmeon.mdc.akamaized.net/files/web/images/fls/uploads/2025/03/cricket-gold-bg.jpg"
  },
  {
    "channel_name": "Billiard TV",
    "channel_page_url": "https://www.freelivesports.tv/channel/billiard-tv/",
    "thumbnail_image_url": "https://gizmeon.mdc.akamaized.net/files/web/images/fls/uploads/2024/11/channels-BilliardTV-683x1024-reduced.jpg",
    "channel_id": 1983,
    "description": "A billiards channel covering 8-ball, 9-ball and 10-ball matches at the highest competitive level, featuring top-ranked players in the sport.",
    "bg_image_url": "https://gizmeon.mdc.akamaized.net/files/web/images/fls/uploads/2025/03/modal-bg.jpg"
  },
  {
    "channel_name": "Inside Arm Wrestling",
    "channel_page_url": "https://www.freelivesports.tv/channel/inside-arm-wrestling/",
    "thumbnail_image_url": "https://gizmeon.mdc.akamaized.net/files/web/images/fls/uploads/2025/01/arm-wrestling-channel-1.jpg",
    "channel_id": 2023,
    "description": "An arm wrestling channel offering round-the-clock coverage of matches, news and analysis dedicated to the sport.",
    "bg_image_url": "https://gizmeon.mdc.akamaized.net/files/web/images/fls/uploads/2025/01/arm-wrestling-bg.jpg"
  },
  {
    "channel_name": "Homerun TV",
    "channel_page_url": "https://www.freelivesports.tv/channel/homerun-tv/",
    "thumbnail_image_url": "https://gizmeon.mdc.akamaized.net/files/web/images/fls/uploads/2024/11/homerun-channel-683x1024-reduced.jpg",
    "channel_id": 2055,
    "description": "A baseball channel keeping fans connected to the sport's action and highlights.",
    "bg_image_url": "https://gizmeon.mdc.akamaized.net/files/web/images/fls/uploads/2024/11/homerun-bg.jpg"
  },
  {
    "channel_name": "Unbeaten",
    "channel_page_url": "https://www.freelivesports.tv/channel/unbeaten/",
    "thumbnail_image_url": "https://gizmeon.mdc.akamaized.net/files/web/images/fls/uploads/2025/09/unbeaten-channel.jpg",
    "channel_id": 2025,
    "description": "A general sports channel offering live matches, highlights, analysis and behind-the-scenes coverage across football, basketball, baseball, combat sports and more.",
    "bg_image_url": "https://gizmeon.mdc.akamaized.net/files/web/images/fls/uploads/2025/09/unbeaten-bg.jpg"
  },
  {
    "channel_name": "Action Plus",
    "channel_page_url": "https://www.freelivesports.tv/channel/action-plus/",
    "thumbnail_image_url": "https://gizmeon.mdc.akamaized.net/files/web/images/fls/uploads/2024/11/action-channel-683x1024-reduced.jpg",
    "channel_id": 1950,
    "description": "A movies channel featuring big-budget action films with major stars, offering nonstop adventure and blockbuster entertainment.",
    "bg_image_url": "https://gizmeon.mdc.akamaized.net/files/web/images/fls/uploads/2024/11/action-bg.jpg"
  },
  {
    "channel_name": "The Boat Show",
    "channel_page_url": "https://www.freelivesports.tv/channel/the-boat-show/",
    "thumbnail_image_url": "https://gizmeon.mdc.akamaized.net/files/web/images/fls/uploads/2024/11/boat-show-channel-683x1024-reduced.jpg",
    "channel_id": null,
    "description": "A boating lifestyle channel touring luxury yachts, sailing ships and pleasurecraft, with reviews of new boats and marine gadgets from destinations worldwide.",
    "bg_image_url": "https://gizmeon.mdc.akamaized.net/files/web/images/fls/uploads/2024/11/boat-show-bg.jpg"
  },
  {
    "channel_name": "GFN Soccer TV",
    "channel_page_url": "https://www.freelivesports.tv/channel/global-fan-network-soccer-tv/",
    "thumbnail_image_url": "https://gizmeon.mdc.akamaized.net/files/web/images/fls/uploads/2024/11/gfn-channel-683x1024-reduced.jpg",
    "channel_id": 2059,
    "description": "A soccer news channel delivering football coverage, analysis and expert reactions from leagues around the world.",
    "bg_image_url": "https://gizmeon.mdc.akamaized.net/files/web/images/fls/uploads/2024/11/gfn-bg.jpg"
  },
  {
    "channel_name": "Documentary+",
    "channel_page_url": "https://www.freelivesports.tv/channel/documentary-plus/",
    "thumbnail_image_url": "https://gizmeon.mdc.akamaized.net/files/web/images/fls/uploads/2024/11/docu-channel-683x1024-reduced.jpg",
    "channel_id": 1951,
    "description": "A channel curating award-winning nonfiction storytelling and documentary films for enthusiasts of the genre."
  },
  {
    "channel_name": "BigPlay Sports Network",
    "channel_page_url": "https://www.freelivesports.tv/channel/bigplay/",
    "thumbnail_image_url": "https://gizmeon.mdc.akamaized.net/files/web/images/fls/uploads/2025/02/bigplay-channel.jpg",
    "channel_id": null,
    "description": "A sports and entertainment channel aimed at younger fans, offering host-led analysis and tailgate-style coverage of the NFL, college football, NBA and MLB.",
    "bg_image_url": "https://gizmeon.mdc.akamaized.net/files/web/images/fls/uploads/2025/02/bigplay-bg.jpg"
  },
  {
    "channel_name": "Earth Trek",
    "channel_page_url": "https://www.freelivesports.tv/channel/earth-trek/",
    "thumbnail_image_url": "https://gizmeon.mdc.akamaized.net/files/web/images/fls/uploads/2024/11/earth-channel-683x1024-reduced.jpg",
    "channel_id": null,
    "description": "A nature and adventure channel exploring wildlife survival through documentaries and adventure series set in the natural world.",
    "bg_image_url": "https://gizmeon.mdc.akamaized.net/files/web/images/fls/uploads/2024/11/earth-bg.jpg"
  },
  {
    "channel_name": "Popular Science",
    "channel_page_url": "https://www.freelivesports.tv/channel/popular-science/",
    "thumbnail_image_url": "https://gizmeon.mdc.akamaized.net/files/web/images/fls/uploads/2024/12/pop-sci2-channel.jpg",
    "channel_id": 1949,
    "description": "A science and technology channel built on the legacy of Popular Science magazine, covering discoveries, rocket launches and everyday science explainers.",
    "bg_image_url": "https://gizmeon.mdc.akamaized.net/files/web/images/fls/uploads/2024/11/pop-sci-bg.jpg"
  },
  {
    "channel_name": "Field & Stream",
    "channel_page_url": "https://www.freelivesports.tv/channel/field-stream/",
    "thumbnail_image_url": "https://gizmeon.mdc.akamaized.net/files/web/images/fls/uploads/2026/03/fieldstream-channel.jpg",
    "channel_id": 1980,
    "description": "An outdoors lifestyle channel inspiring viewers to explore America's natural resources, with entertaining and informative programming for hunting, fishing and outdoor adventure.",
    "bg_image_url": "https://gizmeon.mdc.akamaized.net/files/web/images/fls/uploads/2024/11/outdoor-am-bg.jpg"
  },
  {
    "channel_name": "Escape TV",
    "channel_page_url": "https://www.freelivesports.tv/channel/escape-tv/",
    "thumbnail_image_url": "https://gizmeon.mdc.akamaized.net/files/web/images/fls/uploads/2024/11/escape-channel-683x1024-reduced.jpg",
    "channel_id": 1952,
    "description": "A travel and adventure channel exploring remote destinations, underwater diving spots and distant cultures around the world.",
    "bg_image_url": "https://gizmeon.mdc.akamaized.net/files/web/images/fls/uploads/2024/11/escape-bg.jpg"
  },
  {
    "channel_name": "Big 12 Network",
    "channel_page_url": "https://www.freelivesports.tv/channel/big-12-network/",
    "thumbnail_image_url": "https://gizmeon.mdc.akamaized.net/files/web/images/fls/uploads/2024/11/big12-channel-683x1024-reduced.jpg",
    "channel_id": null,
    "description": "A round-the-clock destination for Big 12 Conference sports, offering highlights, classic games and original college sports programming.",
    "bg_image_url": "https://gizmeon.mdc.akamaized.net/files/web/images/fls/uploads/2024/11/big12-bg.jpg"
  },
  {
    "channel_name": "ACC Digital Network",
    "channel_page_url": "https://www.freelivesports.tv/channel/acc-digital-network/",
    "thumbnail_image_url": "https://gizmeon.mdc.akamaized.net/files/web/images/fls/uploads/2024/11/accdn-channel-683x1024-reduced.jpg",
    "channel_id": null,
    "description": "A channel covering Atlantic Coast Conference sports, with live games, replays and highlights across the conference's football and other athletics."
  },
  {
    "channel_name": "Carbon TV",
    "channel_page_url": "https://www.freelivesports.tv/channel/carbon-tv/",
    "thumbnail_image_url": "https://gizmeon.mdc.akamaized.net/files/web/images/fls/uploads/2024/11/carbon-channel.jpg",
    "channel_id": null,
    "description": "An outdoors lifestyle channel covering hunting, fishing, farming and off-road content for fans of the great outdoors.",
    "bg_image_url": "https://gizmeon.mdc.akamaized.net/files/web/images/fls/uploads/2024/11/carbon-bg.jpg"
  },
  {
    "channel_name": "Commune",
    "channel_page_url": "https://www.freelivesports.tv/channel/commune/",
    "thumbnail_image_url": "https://gizmeon.mdc.akamaized.net/files/web/images/fls/uploads/2024/12/commune2-channel.jpg",
    "channel_id": 1944,
    "description": "A lifestyle channel on the network, grouped alongside wellness and culture programming such as Omstars and Trace Sport Stars.",
    "bg_image_url": "https://gizmeon.mdc.akamaized.net/files/web/images/fls/uploads/2024/11/commune-bg.jpg"
  },
  {
    "channel_name": "Speedvision",
    "channel_page_url": "https://www.freelivesports.tv/channel/speedvision/",
    "thumbnail_image_url": "https://gizmeon.mdc.akamaized.net/files/web/images/fls/uploads/2024/12/speedvision-channel.jpg",
    "channel_id": 2046,
    "description": "An automotive channel covering classic car restorations and custom builds for car enthusiasts."
  },
  {
    "channel_name": "AYM Sports",
    "channel_page_url": "https://www.freelivesports.tv/channel/aym-sports/",
    "thumbnail_image_url": "https://gizmeon.mdc.akamaized.net/files/web/images/fls/uploads/2025/02/aym-channel.jpg",
    "channel_id": 2052,
    "description": "A Spanish-language sports channel covering live sporting events and sports news for over a decade.",
    "bg_image_url": "https://gizmeon.mdc.akamaized.net/files/web/images/fls/uploads/2025/02/aym-bg.jpg"
  },
  {
    "channel_name": "Pickle TV",
    "channel_page_url": "https://www.freelivesports.tv/channel/pickle-tv/",
    "thumbnail_image_url": "https://gizmeon.mdc.akamaized.net/files/web/images/fls/uploads/2025/01/pickle-tv-channel.jpg",
    "channel_id": null,
    "description": "A pickleball channel offering round-the-clock streaming of matches from the sport's rapidly growing competitive scene.",
    "bg_image_url": "https://gizmeon.mdc.akamaized.net/files/web/images/fls/uploads/2025/03/modal-bg.jpg"
  },
  {
    "channel_name": "Red Bull TV",
    "channel_page_url": "https://www.freelivesports.tv/channel/red-bull-tv/",
    "thumbnail_image_url": "https://gizmeon.mdc.akamaized.net/files/web/images/fls/uploads/2025/01/red-bull-channel.jpg",
    "channel_id": null,
    "description": "An action-sports and culture channel featuring world-class athletes, music and adventure content across extreme sports and lifestyle programming.",
    "bg_image_url": "https://gizmeon.mdc.akamaized.net/files/web/images/fls/uploads/2025/01/red-bull-bg.jpg"
  },
  {
    "channel_name": "SportsFishing",
    "channel_page_url": "https://www.freelivesports.tv/channel/sports-fishing/",
    "thumbnail_image_url": "https://gizmeon.mdc.akamaized.net/files/web/images/fls/uploads/2024/11/sportsfishing-channel-683x1024.jpg",
    "channel_id": 1976,
    "description": "A fishing channel on the network, covering angling content within the site's dedicated fishing sports category."
  },
  {
    "channel_name": "beIN Sports Extra",
    "channel_page_url": "https://www.freelivesports.tv/channel/bein-sports-xtra/",
    "thumbnail_image_url": "https://gizmeon.mdc.akamaized.net/files/web/images/fls/uploads/2026/02/bein-extra-channel4.jpg",
    "channel_id": null,
    "description": "A 24/7 sports channel from beIN offering soccer, combat sports and extreme sports coverage alongside news, analysis and studio shows.",
    "bg_image_url": "https://gizmeon.mdc.akamaized.net/files/web/images/fls/uploads/2026/02/bein-extra-v2.jpg"
  },
  {
    "channel_name": "beIN Sports Extra (En Español)",
    "channel_page_url": "https://www.freelivesports.tv/channel/bein-sports-xtra-en-espanol/",
    "thumbnail_image_url": "https://gizmeon.mdc.akamaized.net/files/web/images/fls/uploads/2026/02/bein-extra-spain-channel4.jpg",
    "channel_id": null,
    "description": "The Spanish-language edition of beIN Sports Extra, streaming round-the-clock soccer, combat sports and extreme sports coverage with news and analysis.",
    "bg_image_url": "https://gizmeon.mdc.akamaized.net/files/web/images/fls/uploads/2026/02/bein-extra-v2.jpg"
  },
  {
    "channel_name": "GLORY Kickboxing",
    "channel_page_url": "https://www.freelivesports.tv/channel/glory-kickboxing/",
    "thumbnail_image_url": "https://gizmeon.mdc.akamaized.net/files/web/images/fls/uploads/2024/11/channels-GloryKickboxing-683x1024-reduced.jpg",
    "channel_id": 2033,
    "description": "A kickboxing channel featuring events from the GLORY promotion, showcasing top fighters in the sport's international competitions.",
    "bg_image_url": "https://gizmeon.mdc.akamaized.net/files/web/images/fls/uploads/2025/03/modal-bg.jpg"
  },
  {
    "channel_name": "Adventure Zone Sports Network",
    "channel_page_url": "https://www.freelivesports.tv/channel/adventure-zone-sports-network/",
    "thumbnail_image_url": "https://gizmeon.mdc.akamaized.net/files/web/images/fls/uploads/2025/01/adventure-channel.jpg",
    "channel_id": 1991,
    "description": "An outdoor adventure channel on the network offering action and adventure sports programming.",
    "bg_image_url": "https://gizmeon.mdc.akamaized.net/files/web/images/fls/uploads/2025/01/adventure-bg-v2.jpg"
  },
  {
    "channel_name": "MotorRacing",
    "channel_page_url": "https://www.freelivesports.tv/channel/motorracing/",
    "thumbnail_image_url": "https://gizmeon.mdc.akamaized.net/files/web/images/fls/uploads/2025/01/motoracing-channel.jpg",
    "channel_id": 2045,
    "description": "A round-the-clock motorsports channel covering circuit and off-road racing across two- and four-wheeled disciplines.",
    "bg_image_url": "https://gizmeon.mdc.akamaized.net/files/web/images/fls/uploads/2025/01/motoracing-bg.jpg"
  },
  {
    "channel_name": "HorizonSports",
    "channel_page_url": "https://www.freelivesports.tv/channel/horizonsports/",
    "thumbnail_image_url": "https://gizmeon.mdc.akamaized.net/files/web/images/fls/uploads/2025/01/horizonzone-channel.jpg",
    "channel_id": 1993,
    "description": "A channel covering endurance sports, wellness and adventure films, blending fitness and exploration content.",
    "bg_image_url": "https://gizmeon.mdc.akamaized.net/files/web/images/fls/uploads/2025/01/horizonzone-bg.jpg"
  },
  {
    "channel_name": "World Chase Tag",
    "channel_page_url": "https://www.freelivesports.tv/channel/wct-world-chase-tag/",
    "thumbnail_image_url": "https://gizmeon.mdc.akamaized.net/files/web/images/fls/uploads/2025/01/world-chase-channel.jpg",
    "channel_id": 1965,
    "description": "The channel for the competitive tag league that combines parkour athleticism with the classic game of tag, featuring 1-on-1 pursuit matches in an obstacle arena.",
    "bg_image_url": "https://gizmeon.mdc.akamaized.net/files/web/images/fls/uploads/2025/01/world-chase-bg.jpg"
  },
  {
    "channel_name": "Danger TV",
    "channel_page_url": "https://www.freelivesports.tv/channel/danger-tv/",
    "thumbnail_image_url": "https://gizmeon.mdc.akamaized.net/files/web/images/fls/uploads/2025/05/danger-channel.jpg",
    "channel_id": null,
    "description": "An action-and-adventure channel featuring short-form series and films built around thrill-seeking and extreme content.",
    "bg_image_url": "https://gizmeon.mdc.akamaized.net/files/web/images/fls/uploads/2025/05/danger-bg.jpg"
  },
  {
    "channel_name": "Sports Connect",
    "channel_page_url": "https://www.freelivesports.tv/channel/sports-connect/",
    "thumbnail_image_url": "https://gizmeon.mdc.akamaized.net/files/web/images/fls/uploads/2025/07/sportsconnect-channel.jpg",
    "channel_id": 2051,
    "description": "A general sports channel covering breaking news, match highlights, athlete profiles and behind-the-scenes documentaries across the sporting world.",
    "bg_image_url": "https://gizmeon.mdc.akamaized.net/files/web/images/fls/uploads/2025/07/sportsconnect-bg.png"
  },
  {
    "channel_name": "TyC Sports Fan",
    "channel_page_url": "https://www.freelivesports.tv/channel/tyc-sports-fan/",
    "thumbnail_image_url": "https://gizmeon.mdc.akamaized.net/files/web/images/fls/uploads/2025/11/tyc-channel.jpg",
    "channel_id": null,
    "description": "A Spanish-language sports channel from Argentina's TyC Sports, covering soccer and other major sports for Latin American audiences.",
    "bg_image_url": "https://gizmeon.mdc.akamaized.net/files/web/images/fls/uploads/2025/11/tyc-bg.jpg"
  },
  {
    "channel_name": "Cowboy+ Sports",
    "channel_page_url": "https://www.freelivesports.tv/channel/cowboy-sports/",
    "thumbnail_image_url": "https://gizmeon.mdc.akamaized.net/files/web/images/fls/uploads/2026/03/cowboysports-channel.jpg",
    "channel_id": 1968,
    "description": "A Western sports and lifestyle channel covering rodeo events, with highlights, replays and behind-the-scenes interviews from the rodeo world.",
    "bg_image_url": "https://gizmeon.mdc.akamaized.net/files/web/images/fls/uploads/2025/02/teton-bg.jpg"
  },
  {
    "channel_name": "Joel Osteen Network",
    "channel_page_url": "https://www.freelivesports.tv/channel/joel-osteen-network/",
    "thumbnail_image_url": "https://gizmeon.mdc.akamaized.net/files/web/images/fls/uploads/2025/12/joel-channel.jpg",
    "channel_id": 1947,
    "description": "A faith-based channel featuring pastor Joel Osteen's weekly sermons, original lifestyle programming, and special events broadcast from Lakewood Church."
  },
  {
    "channel_name": "American Stories Network",
    "channel_page_url": "https://www.freelivesports.tv/channel/american-stories-network-asn/",
    "thumbnail_image_url": "https://gizmeon.mdc.akamaized.net/files/web/images/fls/uploads/2025/06/americanstories-channel.jpg",
    "channel_id": 1954,
    "description": "A channel spotlighting real, everyday Americans through uplifting and inspirational human-interest stories.",
    "bg_image_url": "https://gizmeon.mdc.akamaized.net/files/web/images/fls/uploads/2025/06/americanstories-v2-bg.jpg"
  },
  {
    "channel_name": "Waypoint TV",
    "channel_page_url": "https://www.freelivesports.tv/channel/waypoint-tv/",
    "thumbnail_image_url": "https://gizmeon.mdc.akamaized.net/files/web/images/fls/uploads/2026/01/waypoint-channel.jpg",
    "channel_id": 1972,
    "description": "An outdoor adventure channel featuring hunting, fishing and nature expedition programming around the clock.",
    "bg_image_url": "https://gizmeon.mdc.akamaized.net/files/web/images/fls/uploads/2026/01/waypoint-bg.jpg"
  },
  {
    "channel_name": "Game & Fish TV",
    "channel_page_url": "https://www.freelivesports.tv/channel/game-and-fish-tv/",
    "thumbnail_image_url": "https://gizmeon.mdc.akamaized.net/files/web/images/fls/uploads/2025/06/gamefish-channel.jpg",
    "channel_id": null,
    "description": "An outdoors channel covering hunting, fishing, survival skills and wild-game cooking for outdoor enthusiasts.",
    "bg_image_url": "https://gizmeon.mdc.akamaized.net/files/web/images/fls/uploads/2025/06/gamefish-v2-bg.jpg"
  },
  {
    "channel_name": "Skull Bound TV",
    "channel_page_url": "https://www.freelivesports.tv/channel/skull-bound-tv/",
    "thumbnail_image_url": "https://gizmeon.mdc.akamaized.net/files/web/images/fls/uploads/2025/05/skull-channel.jpg",
    "channel_id": 1973,
    "description": "A hunting-themed channel on the network, grouped alongside other outdoor and hunting programming such as Game & Fish TV.",
    "bg_image_url": "https://gizmeon.mdc.akamaized.net/files/web/images/fls/uploads/2025/05/skull-bg.jpg"
  },
  {
    "channel_name": "Tennis Channel T2",
    "channel_page_url": "https://www.freelivesports.tv/channel/tennis-channel-t2/",
    "thumbnail_image_url": "https://gizmeon.mdc.akamaized.net/files/web/images/fls/uploads/2026/03/t2-channel.jpg",
    "channel_id": null,
    "description": "A companion tennis channel offering round-the-clock live and on-demand coverage from the ATP, WTA and ITF tours throughout the season.",
    "bg_image_url": "https://gizmeon.mdc.akamaized.net/files/web/images/fls/uploads/2026/03/t2-bg.jpg"
  },
  {
    "channel_name": "Drone TV",
    "channel_page_url": "https://www.freelivesports.tv/channel/drone-tv/",
    "thumbnail_image_url": "https://gizmeon.mdc.akamaized.net/files/web/images/fls/uploads/2025/08/drone-channel.jpg",
    "channel_id": 2060,
    "description": "A channel featuring aerial drone footage from pilots around the world, offering scenic overhead views for visual entertainment.",
    "bg_image_url": "https://gizmeon.mdc.akamaized.net/files/web/images/fls/uploads/2025/08/drone-bg.jpg"
  },
  {
    "channel_name": "POWERtube TV",
    "channel_page_url": "https://www.freelivesports.tv/channel/powertube-tv/",
    "thumbnail_image_url": "https://gizmeon.mdc.akamaized.net/files/web/images/fls/uploads/2026/02/powertube-channel.jpg",
    "channel_id": 2038,
    "description": "A motorsports channel featuring classic motorsport shows alongside content from racers and builders in the racing community.",
    "bg_image_url": "https://gizmeon.mdc.akamaized.net/files/web/images/fls/uploads/2026/03/powertube-bg-v2.jpg"
  },
  {
    "channel_name": "Bowling TV",
    "channel_page_url": "https://www.freelivesports.tv/channel/bowling-tv/",
    "thumbnail_image_url": "https://gizmeon.mdc.akamaized.net/files/web/images/fls/uploads/2025/11/bowlingtv-channel.jpg",
    "channel_id": 1966,
    "description": "A channel covering live bowling tournaments and match play, featuring commentary and coverage for casual fans and league players alike.",
    "bg_image_url": "https://gizmeon.mdc.akamaized.net/files/web/images/fls/uploads/2025/11/bowlingtv-bg.jpg"
  },
  {
    "channel_name": "MSG Sports Zone",
    "channel_page_url": "https://www.freelivesports.tv/channel/msg-sports-zone/",
    "thumbnail_image_url": "https://gizmeon.mdc.akamaized.net/files/web/images/fls/uploads/2025/11/msg-channel-v3.jpg",
    "channel_id": null,
    "description": "A sports channel focused on New York-area teams, offering news, player interviews, team analysis and behind-the-scenes coverage.",
    "bg_image_url": "https://gizmeon.mdc.akamaized.net/files/web/images/fls/uploads/2025/11/msg-bg-v3.jpg"
  },
  {
    "channel_name": "Golf Network",
    "channel_page_url": "https://www.freelivesports.tv/channel/golf-network/",
    "thumbnail_image_url": "https://gizmeon.mdc.akamaized.net/files/web/images/fls/uploads/2025/08/golfchannel-channel.jpg",
    "channel_id": 2058,
    "description": "Japan's leading golf channel, offering lessons from top teaching professionals, tournament coverage, player interviews and golf news.",
    "bg_image_url": "https://gizmeon.mdc.akamaized.net/files/web/images/fls/uploads/2025/08/golfchannel-bg.jpg"
  },
  {
    "channel_name": "TOP BARÇA (en Espanyol)",
    "channel_page_url": "https://www.freelivesports.tv/channel/top-barca-spanish/",
    "thumbnail_image_url": "https://gizmeon.mdc.akamaized.net/files/web/images/fls/uploads/2026/01/topbarcaspain-channel-v2.jpg",
    "channel_id": 2017,
    "description": "The Spanish-language version of TOP BARÇA, offering round-the-clock FC Barcelona content including delayed match broadcasts, youth and Atlètic team coverage, and original Barça Studios documentaries.",
    "bg_image_url": "https://gizmeon.mdc.akamaized.net/files/web/images/fls/uploads/2026/01/topbarcaspain-bg.jpg"
  },
  {
    "channel_name": "Shooting Sports Life",
    "channel_page_url": "https://www.freelivesports.tv/channel/shooting-sports-life/",
    "thumbnail_image_url": "https://gizmeon.mdc.akamaized.net/files/web/images/fls/uploads/2026/03/shootingsports-channel.jpg",
    "channel_id": 1979,
    "description": "A channel celebrating the shooting sports community, covering competitive shooters, firearms craftsmanship, range life and training for enthusiasts of the discipline.",
    "bg_image_url": "https://gizmeon.mdc.akamaized.net/files/web/images/fls/uploads/2026/03/shootingsports-bg.jpg"
  },
  {
    "channel_name": "Overtime",
    "channel_page_url": "https://www.freelivesports.tv/channel/overtime/",
    "thumbnail_image_url": "https://gizmeon.mdc.akamaized.net/files/web/images/fls/uploads/2026/01/overtime-channel.jpg",
    "channel_id": null,
    "description": "A sports entertainment channel built for younger fans, mixing exclusive highlights, athlete stories and behind-the-scenes content across basketball, football and youth sports culture.",
    "bg_image_url": "https://gizmeon.mdc.akamaized.net/files/web/images/fls/uploads/2026/01/overtime-bg.jpg"
  },
  {
    "channel_name": "NASCAR",
    "channel_page_url": "https://www.freelivesports.tv/channel/nascar/",
    "thumbnail_image_url": "https://gizmeon.mdc.akamaized.net/files/web/images/fls/uploads/2026/01/nascar-channel.jpg",
    "channel_id": 2050,
    "description": "NASCAR's own 24/7 channel, featuring classic races, highlights and archival stock-car racing content.",
    "bg_image_url": "https://gizmeon.mdc.akamaized.net/files/web/images/fls/uploads/2026/01/nascar-bg.jpg"
  },
  {
    "channel_name": "Cirque du Soleil",
    "channel_page_url": "https://www.freelivesports.tv/channel/cirque-du-soleil/",
    "thumbnail_image_url": "https://gizmeon.mdc.akamaized.net/files/web/images/fls/uploads/2026/02/cirque-channel.jpg",
    "channel_id": null,
    "description": "A channel showcasing Cirque du Soleil's acrobatic and circus-arts performances, featuring show footage and behind-the-scenes content from its productions.",
    "bg_image_url": "https://gizmeon.mdc.akamaized.net/files/web/images/fls/uploads/2026/02/cirque-bg.jpg"
  },
  {
    "channel_name": "ProBox TV",
    "channel_page_url": "https://www.freelivesports.tv/channel/probox-tv/",
    "thumbnail_image_url": "https://gizmeon.mdc.akamaized.net/files/web/images/fls/uploads/2026/03/proboctv-channel.jpg",
    "channel_id": null,
    "description": "A boxing channel streaming live fight cards featuring rising prospects and established contenders, alongside highlights and coverage from international fight nights.",
    "bg_image_url": "https://gizmeon.mdc.akamaized.net/files/web/images/fls/uploads/2026/03/proboxtv-bg-v2.png"
  }
];

const STATIC_CHANNEL_VIDEOS = {
  "billiard-tv": "YPlllrTD6gY",
  "choppertown": "yXR3Tq3d9RM",
  "cornhole-tv": "PwEQ5qUxyJk",
  "extreme-sports": "wRtzXRgTX_g",
  "fight-network": "Qr9da3XDj68",
  "fite-24-7": "0BCpSD68hvY",
  "foosball-tv": "4-Fc_k86-Q4",
  "fuel-tv": "gN4d3we0Wuk",
  "gctv": "ANH9tZVbn3o",
  "glory-kickboxing": "KEWE6UIpA5w",
  "hard-knocks": "KoVQZ0pLetQ",
  "horse-and-country": "9HeZUg_JuWo",
  "hunt-fish-tv": "p5bQW-R4ABs",
  "introuble": "QaE1awu4Fi8",
  "kozoom": "Bv2E2ozpz3w",
  "lacrosse-tv": "jZg40MKkTMU",
  "motorvision-tv": "aAL1TUzGC2s",
  "mtrspt1": "qQ1noKRsthc",
  "mvmt-culture": "n-hCh3qZ35s",
  "omstars-tv": "Fpe6fy_aQGg",
  "pfl": "xThCM-btkck",
  "poker-night": "8mHFfxodCIU",
  "powersports-world": "rcEJ4cDQXgs",
  "racer-international": "O0hzTNpbl9o",
  "racer-select": "_oLn0H2na4k",
  "strongman-champions-league": "fC54-_sdvTM",
  "tennis-channel": "3OlkIOB5eAY",
  "tna-wrestling-channel": "1ZaaST-cCxg",
  "wired2fish": "0TZppRlK4D8",
  "world-of-freesports": "T2Wfje9nCm4",
  "world-poker-tour": "qEbRvzNkMhY",
  "wpt-live": "qEbRvzNkMhY",
  "wpt-spain": "qEbRvzNkMhY"
};

export const STATIC_CHANNELS_DATA = STATIC_CHANNELS_DATA_RAW.map((channel) => {
  const slug = channel.channel_page_url?.match(/\/channel\/([^/]+)/)?.[1];
  const youtubeVideoId = slug ? STATIC_CHANNEL_VIDEOS[slug] : undefined;

  return youtubeVideoId ? { ...channel, youtube_video_id: youtubeVideoId } : channel;
});

export const FLS_ALL_CHANNELS_LIST = [
  { name: "Absinthe TV", id: "1990", slug: "absinthe-tv" },
  { name: "ACC Digital Network", id: null, slug: "acc-digital-network" },
  { name: "ACE TV", id: "2054", slug: "ace-tv" },
  { name: "Action Plus", id: null, slug: "action-plus" },
  { name: "Adventure Zone Sports Network", id: "1991", slug: "adventure-zone-sports-network" },
  { name: "American Stories Network", id: null, slug: "american-stories-network" },
  { name: "AYM Sports", id: "2052", slug: "aym-sports" },
  { name: "beIN Sports Xtra", id: null, slug: "bein-sports-xtra" },
  { name: "Big 12 Network", id: null, slug: "big-12-network" },
  { name: "BigPlay Sports Network", id: null, slug: "bigplay-sports-network" },
  { name: "Billiard TV", id: "1983", slug: "billiard-tv" },
  { name: "Carbon TV", id: null, slug: "carbon-tv" },
  { name: "Choppertown", id: "1962", slug: "choppertown" },
  { name: "Commune", id: "1944", slug: "commune" },
  { name: "Cornhole TV", id: "2011", slug: "cornhole-tv" },
  { name: "Cowboy Channel", id: "1968", slug: "cowboy-channel" },
  { name: "Cricket Gold", id: "2015", slug: "cricket-gold" },
  { name: "Danger TV", id: null, slug: "danger-tv" },
  { name: "Documentary Plus", id: null, slug: "documentary-plus" },
  { name: "eClutch Access", id: null, slug: "eclutch-access" },
  { name: "Extreme TV", id: "1993", slug: "extreme-tv" },
  { name: "Field & Stream", id: null, slug: "field-and-stream" },
  { name: "Fight Network", id: "2030", slug: "fight-network" },
  { name: "FITE 24/7", id: null, slug: "fite-247" },
  { name: "FloRacing", id: "2041", slug: "floracing" },
  { name: "Foosball TV", id: "2010", slug: "foosball-tv" },
  { name: "FUEL TV", id: "1989", slug: "fuel-tv" },
  { name: "GCTV", id: "1970", slug: "gctv" },
  { name: "GLORY Kickboxing", id: "2033", slug: "glory-kickboxing" },
  { name: "Golf News Network TV", id: null, slug: "golf-news-network-tv" },
  { name: "GoPro TV", id: "1996", slug: "gopro-tv" },
  { name: "Hard Knocks", id: "2029", slug: "hard-knocks" },
  { name: "Harlem Globetrotters", id: "2020", slug: "harlem-globetrotters" },
  { name: "Hoop TV", id: "2057", slug: "hoop-tv" },
  { name: "Horse & Country", id: "1971", slug: "horse-and-country" },
  { name: "Horse TV", id: "1969", slug: "horse-tv" },
  { name: "Hunt Fish TV", id: "1977", slug: "hunt-fish-tv" },
  { name: "InTrouble", id: "1995", slug: "introuble" },
  { name: "Kozoom", id: "1982", slug: "kozoom" },
  { name: "Lacrosse TV", id: "2012", slug: "lacrosse-tv" },
  { name: "Lucha Plus", id: "2034", slug: "lucha-plus" },
  { name: "MMA-TV", id: "2024", slug: "mma-tv" },
  { name: "More U", id: "1945", slug: "more-u" },
  { name: "MotorRacing", id: "2045", slug: "motorracing" },
  { name: "Motorsport", id: null, slug: "motorsport" },
  { name: "MTRSPT1", id: "2047", slug: "mtrspt1" },
  { name: "NASCAR", id: "2050", slug: "nascar" },
  { name: "NHRA", id: "2043", slug: "nhra" },
  { name: "Pac 12 Insider", id: "2067", slug: "pac-12-insider" },
  { name: "Perfect Game TV", id: "2014", slug: "perfect-game-tv" },
  { name: "PFL", id: "2036", slug: "pfl" },
  { name: "Pickleball TV", id: null, slug: "pickleball-tv" },
  { name: "Poker Night", id: "1986", slug: "poker-night" },
  { name: "PokerGO", id: "1987", slug: "pokergo" },
  { name: "Powersports World", id: "2044", slug: "powersports-world" },
  { name: "POWERtube TV", id: "2038", slug: "powertube-tv" },
  { name: "Premier League Lacrosse", id: "2013", slug: "premier-league-lacrosse" },
  { name: "Pursuit UP", id: "1975", slug: "pursuit-up" },
  { name: "RACER International", id: "2049", slug: "racer-international" },
  { name: "Red Bull TV", id: "1988", slug: "red-bull-tv" },
  { name: "Speedvision", id: "2046", slug: "speedvision" },
  { name: "Sports Connect", id: "2051", slug: "sports-connect" },
  { name: "Sports Illustrated TV", id: "2066", slug: "sports-illustrated-tv" },
  { name: "Stadium", id: null, slug: "stadium" },
  { name: "Strongman Championship League", id: "1964", slug: "strongman-championship-league" },
  { name: "Swerve Combat", id: null, slug: "swerve-combat" },
  { name: "Surf Cinema", id: "1997", slug: "surf-cinema" },
  { name: "Tennis Channel", id: null, slug: "tennis-channel" },
  { name: "Tennis Channel T2", id: null, slug: "tennis-channel-t2" },
  { name: "Tennis TV", id: "2007", slug: "tennis-tv" },
  { name: "TNA Wrestling Channel", id: "2035", slug: "tna-wrestling-channel" },
  { name: "TOP BARÇA", id: "2018", slug: "top-barca" },
  { name: "Trace Sport Stars", id: "1956", slug: "trace-sport-stars" },
  { name: "Wired2Fish TV", id: "1978", slug: "wired2fish-tv" },
  { name: "World Chase Tag", id: "1965", slug: "world-chase-tag" },
  { name: "World Surf League", id: "1998", slug: "world-surf-league" },
  { name: "World Poker Tour (WPT)", id: "1988", slug: "wpt" }
];

export const FLS_SPORTS_GENRES_LIST = [
  { name: "Action Sports", key: "action-extreme-sports", route: "/action-extreme-sports" },
  { name: "American Football", key: "american-football", route: "/football" },
  { name: "Basketball", key: "basketball", route: "/basketball" },
  { name: "Billiards", key: "billiards", route: "/billiards" },
  { name: "Extreme Sports", key: "extreme-sports", route: "/extreme-sports" },
  { name: "Fishing", key: "fishing", route: "/other-sports" },
  { name: "Golf", key: "golf", route: "/other-sports" },
  { name: "Horseback Riding", key: "horseback-riding", route: "/horseback-riding" },
  { name: "Lacrosse", key: "lacrosse", route: "/lacrosse" },
  { name: "MMA", key: "mma", route: "/mixed-martial-arts" },
  { name: "Motorsport", key: "motorsport", route: "/motorsport" },
  { name: "Other Sports", key: "other-sports", route: "/other-sports" },
  { name: "Poker", key: "poker", route: "/poker" }
];
